const configData = document.getElementById('vd-config-data');

export const currency = JSON.parse(configData.dataset.currencies);
export const csrfToken = configData.dataset.csrfToken;
export const minAvgPriceChartResults = Number(configData.dataset.minAvgPriceChartResults);
export const minPriceVsOdoChartsResults = Number(configData.dataset.minPriceVsOdoChartsResults);
export const recaptchaSiteKeyV2 = configData.dataset.recaptchaSiteKeyV2;
export const recaptchaSiteKeyV3 = configData.dataset.recaptchaSiteKeyV3;

